// extracted by mini-css-extract-plugin
module.exports = {"container":"percentage-button_container__1gaG6","dark":"percentage-button_dark__mLJW5","text":"percentage-button_text__3jfAi","active":"percentage-button_active__1cME0"};